// Set the key we'll use in local storage.
// Go to Chrome dev tools, application tab, click "Local Storage" and "http://localhost:8080"
// and you'll see this key set below (if logged in):
import {CLEAR_ALL_DATA,
    UPDATE_AUTH,
    UPDATE_ROUTES,
    UPDATE_USER,
    SYNC_DATA
} from "./mutations-type";

export const STORAGE_KEY = 'abft_intranet'

var _ = require('underscore');

// initial state
const state = {
    syncedData: {
        auth: {
            isLoggedIn: false,
            accessToken: null,
            refreshToken: null
        },
        user: {
            name: ''
        },
        route:[]
    },
    notSyncedData: {
        appnav: {
            searchText: '',
            searchTimestamp: null
        },
    }
}

// mutations
const mutations = {
    [UPDATE_USER](state, message) {
        state.syncedData.user = message;
    },
    [SYNC_DATA](state) {
        if (localStorage.getItem(STORAGE_KEY)) {
            state.syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
        }
    },
    [UPDATE_AUTH](state, message) {
        state.syncedData.auth = message;
    },
    [UPDATE_ROUTES](state, message) {
        state.syncedData.routes = message;
    },
    [CLEAR_ALL_DATA](state, message) {
        // Auth
        state.syncedData.auth.isLoggedIn = false
        state.syncedData.auth.accessToken = null
        state.syncedData.auth.refreshToken = null
        // User
        state.syncedData.user.name = ''
    },
}

const actions = {
    setMainUser({commit}, msg) {
        commit(UPDATE_USER, msg)
    },
    setRoutes({commit}, msg) {
        commit(UPDATE_ROUTES, msg)
    },
    setAuth({commit}, msg) {
        commit(UPDATE_USER, msg)
    },
    syncLocalStorage({SYNC_DATA}) {
        commit(SYNC_DATA, msg)
    }
}

const getters = {
    getMainUser: state => {
        return state.syncedData.user;
    },
    getAuth: state => {
        return state.syncedData.auth;
    },
    getRoutes:state => {
        return state.syncedData.routes
    },
    getRoute(state){
        var self = this;
        return function (routeName) {
            return process.env.API_URL+   state.syncedData.routes[routeName];
        };
    },
    getSyncLocalStorage: state => {
        if (localStorage.getItem(STORAGE_KEY)) {
            state.syncedData = JSON.parse(localStorage.getItem(STORAGE_KEY))
        }
        return Object.assign(state.syncedData, state.notSyncedData);
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/local-storage.js